const PASSCODE_MUTATIONS = ['passcode-auth', 'mut'] as const;

export const passcodeMutationKeys = {
  all: () => PASSCODE_MUTATIONS,
  send: () => [...PASSCODE_MUTATIONS, 'send'] as const,
  verify: () => [...PASSCODE_MUTATIONS, 'verify'] as const,
  lookup: () => [...PASSCODE_MUTATIONS, 'lookup'] as const,
  passwordLogin: () => [...PASSCODE_MUTATIONS, 'password-login'] as const,
  setPassword: () => [...PASSCODE_MUTATIONS, 'set-password'] as const,
};

const CHANNEL_SWITCH_MUTATIONS = ['passcode-auth', 'channel-switch', 'mut'] as const;

export const channelSwitchMutationKeys = {
  code: () => [...CHANNEL_SWITCH_MUTATIONS, 'code'] as const,
  verify: () => [...CHANNEL_SWITCH_MUTATIONS, 'verify'] as const,
};
